import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Layout } from '../../components/Layout/Layout';
import { useTelegram } from '../../hooks/useTelegram';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 20px;
`;

const WelcomeMessage = styled.h1`
  color: var(--tg-theme-text-color, #000);
  font-size: 24px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Description = styled.p`
  color: var(--tg-theme-hint-color, #666);
  font-size: 16px;
  max-width: 400px;
  line-height: 1.5;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const NavigationButton = styled.button`
  margin-top: 24px;
  padding: 12px 24px;
  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--primary-700) 100%);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-lg);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 20px;
  }
`;

export const Home: React.FC = () => {
  const navigate = useNavigate();
  const { isTelegramWebApp } = useTelegram();

  useEffect(() => {
    // Auto-redirect to sessions if accessed via Telegram Web App
    if (isTelegramWebApp) {
      const timer = setTimeout(() => {
        navigate('/sessions');
      }, 1500); // 1.5 second delay to show welcome message
      
      return () => clearTimeout(timer);
    }
  }, [isTelegramWebApp, navigate]);

  const handleGoToSessions = () => {
    navigate('/sessions');
  };

  return (
    <Layout title="Home">
      <Container>
        <WelcomeMessage>
          Welcome to Caller Agent Admin Panel
        </WelcomeMessage>
        <Description>
          {isTelegramWebApp 
            ? "Redirecting to Sessions..." 
            : "Use the navigation to access Sessions and manage your caller agent data."
          }
        </Description>
        {!isTelegramWebApp && (
          <NavigationButton onClick={handleGoToSessions}>
            📋 Go to Sessions
          </NavigationButton>
        )}
      </Container>
    </Layout>
  );
};